// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeaderGhost_wrapper__fbW8C"};